// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WechatQr_wrapper_Yzrqj","container":"WechatQr_container_2hNkL","title":"WechatQr_title_3p1EH","logo":"WechatQr_logo_3kK6b"};